// extracted by mini-css-extract-plugin
module.exports = {"ModalRetirada":"ModalRetirada_ModalRetirada__1Sy0D","header":"ModalRetirada_header__3d6lu","container":"ModalRetirada_container__1l5pF","button":"ModalRetirada_button__1khSO"};